const MONGO_OBJECT_ID = /^[a-fA-F0-9]{24}$/;

export function isInboxChatObjectId(value) {
  if (value == null || value === '') return false;
  return MONGO_OBJECT_ID.test(String(value));
}

export function resolveTemplateCustomerId(currentCustomer, conversation) {
  return currentCustomer?.customerId
    || currentCustomer?.customer_id
    || currentCustomer?.id
    || conversation?.customerId
    || conversation?.customer_id;
}

export function conversationBelongsToCustomer(conversation, customerId) {
  if (!conversation || customerId == null || customerId === '') return false;
  const conversationCustomerId = conversation.customerId ?? conversation.customer_id;
  return conversationCustomerId != null && String(conversationCustomerId) === String(customerId);
}

export function resolveTemplateChatId(conversation, customerId) {
  if (!conversationBelongsToCustomer(conversation, customerId)) return undefined;
  const chatId = conversation.id ?? conversation.attributes?.id;
  if (chatId == null || String(chatId) === String(customerId)) return undefined;
  return String(chatId);
}

export function resolveMsOutboundChatId(chatId, customerId) {
  if (chatId) return String(chatId);
  if (isInboxChatObjectId(customerId)) return String(customerId);
  return undefined;
}
